<template>
  <b-row>
    <b-col md="7">
      <b-card>
        <b-row>
          <b-col cols="12 mb-1">
            <b-badge variant="light-warning" v-if="form.status === 1">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-primary" v-else-if="form.status === 2">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-danger" v-else-if="form.status === 3">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-primary" v-else-if="form.status === 4">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-danger" v-else-if="form.status === 5">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-primary" v-else-if="form.status === 6">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-success" v-else-if="form.status === 7">{{
              form.status_name
            }}</b-badge>
          </b-col>
          <b-col cols="12" md="12">
            <b-row>
              <b-col cols="6" md="6" class="text-left"> Code </b-col>
              <b-col cols="6" md="6" class="text-right font-weight-bolder">
                {{ form.code }}
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="6" md="6" class="text-left"> Date </b-col>
              <b-col cols="6" md="6" class="text-right font-weight-bolder">
                {{ moment(form.created_at) }} WIB
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="6" md="6" class="text-left"> Sales Name </b-col>
              <b-col cols="6" md="6" class="text-right font-weight-bolder">
                {{ form.user_name }}
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="6" md="6" class="text-left"> Description </b-col>
              <b-col
                cols="6"
                md="6"
                class="text-right font-weight-bolder"
                v-if="form.description !== ''"
              >
                {{ form.description }}
              </b-col>
              <b-col
                cols="6"
                md="6"
                class="text-right font-weight-bolder"
                v-else
              >
                -
              </b-col>
            </b-row>
            <hr v-if="form.status === 3" />
            <b-row v-if="form.status === 3">
              <b-col cols="6" md="6" class="text-left"> Reject Reason </b-col>
              <b-col cols="6" md="6" class="text-right font-weight-bolder">
                {{ reject_reason }}
              </b-col>
            </b-row>
            <hr v-if="form.status === 5" />
            <b-row v-if="form.status === 5">
              <b-col cols="6" md="6" class="text-left"> Cancel Reason </b-col>
              <b-col cols="6" md="6" class="text-right font-weight-bolder">
                {{ cancel_reason }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <label class="font-weight-bolder text-primary mb-1" for="product"
          >List Items</label
        >
        <b-row class="mb-1" v-for="(product, list) in products" :key="list">
          <b-col cols="12">
            <b-row>
              <b-col cols="12" md="12">
                <b-img
                  thumbnail
                  fluid
                  :src="product.image"
                  width="150"
                  class="float-left mr-1"
                  style="height: 150px; object-fit: contain"
                />
                <b-row>
                  <b-col md="12">
                    <div class="mb-2 font-weight-bolder">
                      {{ product.code }}
                    </div>
                    <div class="text-success font-weight-bolder">
                      {{ product.name }} ({{ product.category }})
                    </div>
                    <div>{{ product.qty }} {{ product.unit }}</div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- <b-row>
                    <b-col md="6" class="font-weight-bolder text-right">Total</b-col>
                    <b-col md="6" class="font-weight-bolder text-primary text-right"><span class="mr-1">{{ formatRupiah(form.purchase_price) }}</span></b-col>
                </b-row> -->
      </b-card>

      <b-row v-if="form.status === 2">
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            block
            @click="confirmReceive()"
            v-if="permissions.includes('sales-borrow-received')"
          >
            Confirm Receive
          </b-button>
        </b-col>
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="danger"
            class="mr-1"
            block
            v-b-modal.modal-cancel
            v-if="permissions.includes('sales-borrow-cancel')"
          >
            Cancel Borrow
          </b-button>
        </b-col>
      </b-row>
      <b-row
        v-if="
          permissions.includes('sales-borrow-confirm-return') &&
          form.status === 4
        "
      >
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            block
            @click="confirmReturn()"
          >
            Confirm Return
          </b-button>
        </b-col>
      </b-row>
      <!-- modal cancel -->
      <b-modal
        id="modal-cancel"
        title="Cancel Form"
        ok-title="Cancel"
        cancel-variant="outline-secondary"
        hide-footer
      >
        <validation-observer ref="loginValidation">
          <b-form ref="form" @submit.prevent>
            <b-form-group
              :state="errors"
              label="Cancel Reason"
              label-for="cancel"
              invalid-feedback="Cancel Reason required"
            >
              <validation-provider
                #default="{ errors }"
                name="cancel"
                rules="required"
              >
                <b-form-input
                  id="cancel"
                  name="cancel"
                  type="text"
                  v-model="cancel_reason"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Cancel Reason"
                  required="required"
                />
                <small class="text-danger">{{ errors[0] || errMessage }}</small>
              </validation-provider>
            </b-form-group>

            <b-row>
              <b-col>
                <b-button
                  class="mt-3"
                  type="submit"
                  variant="danger"
                  block
                  @click="cancelBorrow()"
                >
                  Cancel Borrow
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
      <!-- end modal reject -->
    </b-col>
    <b-col md="5">
      <b-card>
        <label class="font-weight-bolder text-primary mb-2" for="product"
          >Order History</label
        >
        <app-timeline>
          <app-timeline-item
            v-for="(log, index) in logs"
            :key="index"
            :title="log.description"
            subtitle=""
            :time="moment(log.created_at)"
            :variant="log.variant"
          />
        </app-timeline>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BImg,
  BContainer,
  BBadge,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import { $themeConfig } from "@themeConfig";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    ToastificationContent,
    BImg,
    BContainer,
    ValidationProvider,
    ValidationObserver,
    BBadge,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        status: null,
        status_name: "",
        code: "",
        created_at: "",
        user_id: null,
        user_name: "",
        description: "",
      },
      permissions: [],
      reject_reason: "",
      cancel_reason: "",
      products: [],
      logs: [],
      url: "",
      errors: "",
      errMessage: "",
    };
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
    this.getDetailsItem();
    this.getLogs();
  },
  methods: {
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    moment(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm");
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("sales/borrow/" + id).then((response) => {
        // console.log(response.data.data)
        this.form.status = response.data.data.status;
        this.form.status_name = response.data.data.status_name;
        this.form.code = response.data.data.code;
        this.form.created_at = response.data.data.created_at;
        this.form.user_id = response.data.data.user_id;
        this.form.user_name = response.data.data.user_name;
        this.form.description = response.data.data.description;
        this.reject_reason = response.data.data.reject_reason;
        this.cancel_reason = response.data.data.cancel_reason;
      });
    },
    getDetailsItem() {
      const id = this.$route.params.id;
      this.$http.get("sales/borrow/" + id + "/items").then((response) => {
        // console.log(response.data.data)
        const { baseUrl } = $themeConfig.app;
        this.url = baseUrl;
        this.url += "storage/product/";

        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            category: datas[i].product_category,
            code: datas[i].product_code,
            image: this.url + datas[i].product_image,
            name: datas[i].product_name,
            product_id: datas[i].product_id,
            unit: datas[i].product_unit,
            qty: datas[i].qty,
          };
          this.products.push($data);
        }
        // console.log(this.products)
      });
    },
    getLogs() {
      const id = this.$route.params.id;
      this.$http.get("sales/borrow/" + id + "/logs").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          if (this.form.status === 3) {
            var $data = {
              description: datas[i].description,
              created_at: datas[i].created_at,
              variant: "danger",
            };
            this.logs.push($data);
          } else if (this.form.status === 7) {
            var $data = {
              description: datas[i].description,
              created_at: datas[i].created_at,
              variant: "secondary",
            };
            this.logs.push($data);
          } else if (i === datas.length - 1) {
            var $data = {
              description: datas[i].description,
              created_at: datas[i].created_at,
              variant: "primary",
            };
            this.logs.push($data);
          } else {
            var $data = {
              description: datas[i].description,
              created_at: datas[i].created_at,
              variant: "secondary",
            };
            this.logs.push($data);
          }
        }
      });
    },
    confirmReceive() {
      const id = this.$route.params.id;
      this.$http
        .post("sales/borrow/" + id + "/received")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Confirm Received",
              variant: "success",
            },
          });
          location.href = "/sales/sales-borrow-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    cancelBorrow() {
      const id = this.$route.params.id;
      this.$http
        .post("sales/borrow/" + id + "/cancel", {
          cancel_reason: this.cancel_reason,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Borrow Request Canceled",
              variant: "danger",
            },
          });
          location.href = "/sales/sales-borrow-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    confirmReturn() {
      const id = this.$route.params.id;
      this.$http
        .post("sales/borrow/" + id + "/return")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Returned",
              variant: "success",
            },
          });
          location.href = "/sales/sales-borrow-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>